import { Controller } from "@hotwired/stimulus";
import { saveModelingControls } from "../scenario_modeling/save_controls";

export default class extends Controller {
  static values = {
    saveUrl: String,
    continueUrl: String,
  };

  async saveAndContinue(event) {
    event.preventDefault();
    if (!this.saveUrlValue || !this.continueUrlValue) return;

    try {
      await saveModelingControls(this.saveUrlValue);
      window.location.assign(this.continueUrlValue);
    } catch (error) {
      window.alert(error.message || "Could not save your modeling changes. Please try again.");
    }
  }
}
